export const translations = {
  en: {
    brand: "TrustConApp",
    brand_subtitle: "Turn any website into a mobile app",
    nav_quick: "Quick App",
    nav_build: "Build App",

    quick_title: "Quick App",
    quick_subtitle: "Paste a URL, get a QR code, install on your phone — in seconds.",
    quick_url_label: "Website URL",
    quick_url_placeholder: "https://example.com",
    quick_generate: "Generate QR",
    quick_open: "Open website",
    quick_share: "Share QR",
    quick_share_copied: "Link copied!",
    quick_download: "Download QR",
    quick_no_url: "Paste a URL first",

    home_pick_mode: "Pick your path",
    home_quick_card_title: "Quick App",
    home_quick_card_desc: "No signup. Paste a URL, get a QR + install instructions instantly.",
    home_quick_card_cta: "Try Quick App",
    home_build_card_title: "Build App",
    home_build_card_desc: "Real PWA: custom icon, theme color, manifest, service worker, install prompt.",
    home_build_card_cta: "Build a real app",
    home_quick_chip: "Free · No signup",
    home_build_chip: "Free during launch",

    early_access_chip: "Early Access",
    early_access_banner: "Free during early access — until official launch.",
    early_access_short: "Free during early access",
    nav_home: "Home",
    nav_pricing: "Pricing",
    nav_dashboard: "Dashboard",
    nav_login: "Login",
    nav_register: "Sign up",
    nav_logout: "Logout",
    nav_create: "Create app",

    hero_eyebrow: "No-code · One tap install",
    hero_title_1: "Turn any website into",
    hero_title_2: "an app on your phone",
    hero_title_3: "with one tap.",
    hero_sub: "Stop searching for your favorite sites. Pin them to your home screen as real apps and open them with a single tap — no App Store, no coding.",
    hero_cta_primary: "Pin my favorite sites",
    hero_cta_secondary: "See pricing",
    hero_pill_1: "PWA · Installable",
    hero_pill_2: "iOS · Android",
    hero_pill_3: "No App Store fees",

    owners_eyebrow: "For website owners",
    owners_title: "Let your visitors install your site as an app",
    owners_sub: "Add a one-tap “Install as app” button to your site. Bring users back instantly — no need to remember a URL or search for it again.",
    owners_cta: "Create your install button",
    owners_b1: "Bigger return-visit rate",
    owners_b2: "Live on the home screen",
    owners_b3: "Works on iOS & Android",

    features_title: "Why people love it",
    features_1_title: "Paste & ship",
    features_1_desc: "Drop your link, we auto-fetch the title and favicon.",
    features_2_title: "Custom branding",
    features_2_desc: "Pick your icon, theme color and splash. Yours, not ours.",
    features_3_title: "QR install",
    features_3_desc: "Share a QR code — visitors install with a single tap.",
    features_4_title: "Pro for $1/mo",
    features_4_desc: "Unlimited apps, no badge, priority load.",

    how_title: "How it works",
    how_1: "Paste your URL",
    how_2: "Customize icon & colors",
    how_3: "Share the install link",

    pricing_title: "Simple pricing",
    pricing_sub: "Start free. Upgrade when you outgrow it.",
    plan_free: "Free",
    plan_free_desc: "Try it out, ship 3 apps.",
    plan_pro: "Pro",
    plan_pro_desc: "For makers shipping a lot.",
    plan_pro_price: "$0",
    plan_pro_per: " · launch",
    plan_pro_original: "$1/mo",
    plan_free_features: ["Up to 3 apps", "PWA install link", "QR code", "TrustConApp badge"],
    plan_pro_features: ["Unlimited apps", "Custom branding", "Remove TrustConApp badge", "Priority support"],
    plan_cta_free: "Start free",
    plan_cta_pro: "Activate (free now)",

    auth_login_title: "Welcome back",
    auth_register_title: "Create your account",
    auth_email: "Email",
    auth_password: "Password",
    auth_name: "Your name",
    auth_login_btn: "Log in",
    auth_register_btn: "Sign up",
    auth_no_account: "No account?",
    auth_have_account: "Already have an account?",
    auth_login_link: "Log in",
    auth_register_link: "Sign up",

    dash_title: "Your apps",
    dash_sub: "Manage every PWA you've built. Tap any card to edit.",
    dash_empty_title: "No apps yet",
    dash_empty_sub: "Create your first PWA in under a minute.",
    dash_empty_cta: "Create my first app",
    dash_create: "New app",

    builder_new_title: "Create a new app",
    builder_edit_title: "Edit app",
    builder_url_label: "Website URL",
    builder_url_placeholder: "https://example.com",
    builder_fetch: "Auto-fill",
    builder_name_label: "App name",
    builder_short_name_label: "Short name (home screen)",
    builder_desc_label: "Description",
    builder_icon_label: "Icon (URL or upload)",
    builder_icon_upload: "Upload",
    builder_icon_uploading: "Uploading…",
    builder_icon_clear: "Clear",
    builder_icon_url_placeholder: "Paste icon URL or upload a file",
    builder_icon_size_hint: "PNG / JPG / WEBP · max 2MB · square recommended",
    builder_theme_label: "Theme color",
    builder_bg_label: "Background color",
    builder_display_label: "Display mode",
    builder_orientation_label: "Orientation",
    builder_save: "Save app",
    builder_cancel: "Cancel",
    builder_preview: "Preview",
    builder_open_install: "Open install page",
    builder_copy_link: "Copy install link",
    builder_link_copied: "Install link copied!",
    builder_delete: "Delete",
    builder_delete_confirm: "Delete this app permanently?",

    install_title: "Install on your phone",
    install_sub: "Scan with your phone or open this link on mobile.",
    install_one_tap: "Install now",
    install_one_tap_unavailable: "Use the Share menu (iOS) or browser menu (Android) to install",
    install_installed: "Installed ✓ Open it from your home screen",
    install_ios: "On iPhone (Safari)",
    install_ios_1: "Tap the Share icon",
    install_ios_2: "Choose “Add to Home Screen”",
    install_ios_3: "Tap “Add”",
    install_android: "On Android (Chrome)",
    install_android_1: "Tap the menu (⋮)",
    install_android_2: "Choose “Install app” or “Add to Home screen”",
    install_android_3: "Confirm install",
    install_open: "Open the website",
    install_made_with: "Made with ConApp",

    common_loading: "Loading…",
    common_error: "Something went wrong",
    common_required: "This field is required",

    nav_admin: "Admin",
    admin_title: "Admin Console",
    admin_subtitle: "Manage users, invoices and platform policies",
    admin_nav_dashboard: "Overview",
    admin_nav_users: "Users",
    admin_nav_invoices: "Invoices",
    admin_nav_policies: "Policies",
    admin_stat_users: "Users",
    admin_stat_apps: "Apps created",
    admin_stat_pro: "Pro subscribers",
    admin_stat_free: "Free users",
    admin_stat_invoices: "Invoices",
    admin_stat_revenue: "Revenue",
    admin_stat_revenue_hint: "Lifetime — once Stripe is connected",

    admin_users_title: "Users",
    admin_users_count: "users",
    admin_users_col_name: "Name",
    admin_users_col_email: "Email",
    admin_users_col_plan: "Plan",
    admin_users_col_apps: "Apps",
    admin_users_col_joined: "Joined",
    admin_users_col_actions: "Actions",
    admin_users_upgrade: "Upgrade Pro",
    admin_users_downgrade: "Downgrade",
    admin_users_delete_confirm: "Delete this user and all their apps?",

    admin_invoices_title: "Invoices",
    admin_invoices_count: "invoices",
    admin_invoices_col_id: "Invoice ID",
    admin_invoices_col_user: "User",
    admin_invoices_col_amount: "Amount",
    admin_invoices_col_status: "Status",
    admin_invoices_col_date: "Date",
    admin_invoices_empty_title: "No invoices yet",
    admin_invoices_empty_sub: "Once a Stripe subscription is paid, invoices will appear here automatically.",
    admin_invoices_stripe_pending: "Stripe not connected",

    admin_policy_terms: "Terms of Service",
    admin_policy_privacy: "Privacy Policy",
    admin_policy_refund: "Refund Policy",
    admin_policy_cookies: "Cookies Policy",
    admin_policy_title_label: "Policy title",
    admin_policy_content_label: "Content (Markdown — ## for headings)",
    admin_policy_markdown_hint: "Tip: Use `## ` at the start of a line for a section heading; blank line for new paragraph.",
    admin_policy_save: "Save policy",
    admin_policy_saved: "Saved ✓",
    admin_policy_preview: "Preview public page",
    admin_policy_updated: "Last updated",

    cookie_banner_text: "We use essential cookies to make ConApp work. Analytics cookies are only set after you accept.",
    cookie_banner_link: "Read our Cookies Policy",
    cookie_accept: "Accept",
    cookie_decline: "Essential only",

    footer_legal: "Legal",
    footer_terms: "Terms",
    footer_privacy: "Privacy",
    footer_refund: "Refunds",
    footer_cookies: "Cookies",
  },
  ar: {
    brand: "TrustConApp",
    brand_subtitle: "حوّل أي موقع إلى تطبيق على هاتفك",
    nav_quick: "تطبيق سريع",
    nav_build: "إنشاء تطبيق",

    quick_title: "تطبيق سريع",
    quick_subtitle: "ضع الرابط، استلم كود QR، وثبّته على هاتفك — خلال ثوانٍ.",
    quick_url_label: "رابط الموقع",
    quick_url_placeholder: "https://example.com",
    quick_generate: "ولّد QR",
    quick_open: "افتح الموقع",
    quick_share: "شارك QR",
    quick_share_copied: "تم نسخ الرابط!",
    quick_download: "تحميل QR",
    quick_no_url: "ضع رابطاً أولاً",

    home_pick_mode: "اختر طريقك",
    home_quick_card_title: "تطبيق سريع",
    home_quick_card_desc: "بدون تسجيل. ضع الرابط، احصل على QR + خطوات التثبيت فوراً.",
    home_quick_card_cta: "جرّب التطبيق السريع",
    home_build_card_title: "إنشاء تطبيق",
    home_build_card_desc: "PWA حقيقي: أيقونة مخصّصة، ألوان، manifest، service worker، زر تثبيت.",
    home_build_card_cta: "ابنِ تطبيقاً حقيقياً",
    home_quick_chip: "مجاناً · بدون تسجيل",
    home_build_chip: "مجاناً حتى الإطلاق",

    early_access_chip: "نسخة مبكّرة",
    early_access_banner: "كل المزايا مجاناً خلال فترة النسخة المبكّرة — حتى الإطلاق الرسمي.",
    early_access_short: "مجاناً خلال النسخة المبكّرة",
    nav_home: "الرئيسية",
    nav_pricing: "الباقات",
    nav_dashboard: "لوحة التحكم",
    nav_login: "دخول",
    nav_register: "إنشاء حساب",
    nav_logout: "خروج",
    nav_create: "تطبيق جديد",

    hero_eyebrow: "بدون كود · بنقرة واحدة",
    hero_title_1: "حوّل أي موقع إلى",
    hero_title_2: "تطبيق على هاتفك",
    hero_title_3: "بنقرة واحدة.",
    hero_sub: "لا داعي للبحث مرّة أخرى عن مواقعك المفضّلة. ثبّتها على شاشة هاتفك كتطبيق حقيقي وافتحها بنقرة واحدة — بدون متاجر تطبيقات، وبدون برمجة.",
    hero_cta_primary: "ثبّت موقعك المفضّل",
    hero_cta_secondary: "شاهد الباقات",
    hero_pill_1: "PWA · قابل للتثبيت",
    hero_pill_2: "iOS · أندرويد",
    hero_pill_3: "بدون رسوم متاجر",

    owners_eyebrow: "لأصحاب المواقع",
    owners_title: "خلّ زوّارك يثبّتون موقعك كتطبيق",
    owners_sub: "أضف زر «ثبّت كتطبيق» على موقعك. زوّارك يرجعون إليك بنقرة واحدة من شاشتهم الرئيسية — بدون ما يبحثون عن الرابط من جديد.",
    owners_cta: "أنشئ زر التثبيت الآن",
    owners_b1: "ارتفاع معدل العودة",
    owners_b2: "حضور دائم على شاشة الهاتف",
    owners_b3: "يعمل على iOS وأندرويد",

    features_title: "ليش الناس تحبّه",
    features_1_title: "الصق وانشر",
    features_1_desc: "ضع رابطك، نجلب العنوان والأيقونة تلقائياً.",
    features_2_title: "هويتك أنت",
    features_2_desc: "اختر الأيقونة، اللون، وشاشة البداية. ملكك بالكامل.",
    features_3_title: "تثبيت بـ QR",
    features_3_desc: "شارك كود QR — الزائر يثبّت التطبيق بنقرة.",
    features_4_title: "Pro بـ ١$ فقط",
    features_4_desc: "تطبيقات غير محدودة، بدون شعارنا، تحميل أسرع.",

    how_title: "كيف يعمل",
    how_1: "الصق الرابط",
    how_2: "خصّص الأيقونة والألوان",
    how_3: "شارك رابط التثبيت",

    pricing_title: "أسعار بسيطة",
    pricing_sub: "ابدأ مجاناً. ترقّى عندما تكبر.",
    plan_free: "المجانية",
    plan_free_desc: "جرّب وأنشئ ٣ تطبيقات.",
    plan_pro: "Pro",
    plan_pro_desc: "للصنّاع الذين يطلقون الكثير.",
    plan_pro_price: "٠$",
    plan_pro_per: " · إطلاق",
    plan_pro_original: "١$/شهرياً",
    plan_free_features: ["حتى ٣ تطبيقات", "رابط تثبيت PWA", "كود QR", "شارة TrustConApp"],
    plan_pro_features: ["تطبيقات غير محدودة", "هوية مخصّصة", "إزالة شارة TrustConApp", "دعم أولوية"],
    plan_cta_free: "ابدأ مجاناً",
    plan_cta_pro: "فعّل (مجاناً الآن)",

    auth_login_title: "أهلاً بعودتك",
    auth_register_title: "أنشئ حسابك",
    auth_email: "البريد الإلكتروني",
    auth_password: "كلمة المرور",
    auth_name: "اسمك",
    auth_login_btn: "دخول",
    auth_register_btn: "إنشاء حساب",
    auth_no_account: "ما عندك حساب؟",
    auth_have_account: "عندك حساب؟",
    auth_login_link: "ادخل",
    auth_register_link: "أنشئ حساب",

    dash_title: "تطبيقاتك",
    dash_sub: "أدِر كل تطبيق PWA أنشأته. اضغط على أي بطاقة للتعديل.",
    dash_empty_title: "لا يوجد تطبيقات بعد",
    dash_empty_sub: "أنشئ أول تطبيق PWA في أقل من دقيقة.",
    dash_empty_cta: "أنشئ أول تطبيق",
    dash_create: "تطبيق جديد",

    builder_new_title: "إنشاء تطبيق جديد",
    builder_edit_title: "تعديل التطبيق",
    builder_url_label: "رابط الموقع",
    builder_url_placeholder: "https://example.com",
    builder_fetch: "تعبئة تلقائية",
    builder_name_label: "اسم التطبيق",
    builder_short_name_label: "اسم قصير (الشاشة الرئيسية)",
    builder_desc_label: "الوصف",
    builder_icon_label: "الأيقونة (رابط أو رفع ملف)",
    builder_icon_upload: "رفع",
    builder_icon_uploading: "جارٍ الرفع…",
    builder_icon_clear: "مسح",
    builder_icon_url_placeholder: "ضع رابط الأيقونة أو ارفع ملفاً",
    builder_icon_size_hint: "PNG / JPG / WEBP · حتى ٢ ميجا · يفضّل صورة مربّعة",
    builder_theme_label: "لون الواجهة",
    builder_bg_label: "لون الخلفية",
    builder_display_label: "وضع العرض",
    builder_orientation_label: "الاتجاه",
    builder_save: "حفظ التطبيق",
    builder_cancel: "إلغاء",
    builder_preview: "معاينة",
    builder_open_install: "صفحة التثبيت",
    builder_copy_link: "انسخ رابط التثبيت",
    builder_link_copied: "تم نسخ الرابط!",
    builder_delete: "حذف",
    builder_delete_confirm: "هل تريد حذف هذا التطبيق نهائياً؟",

    install_title: "ثبّته على هاتفك",
    install_sub: "امسح الكود من هاتفك أو افتح الرابط على الموبايل.",
    install_one_tap: "ثبّت الآن",
    install_one_tap_unavailable: "استخدم قائمة المشاركة (iOS) أو قائمة المتصفّح (أندرويد) للتثبيت",
    install_installed: "تم التثبيت ✓ افتحه من الشاشة الرئيسية",
    install_ios: "على آيفون (Safari)",
    install_ios_1: "اضغط أيقونة المشاركة",
    install_ios_2: "اختر «إضافة إلى الشاشة الرئيسية»",
    install_ios_3: "اضغط «إضافة»",
    install_android: "على أندرويد (Chrome)",
    install_android_1: "اضغط القائمة (⋮)",
    install_android_2: "اختر «تثبيت التطبيق» أو «إضافة إلى الشاشة الرئيسية»",
    install_android_3: "أكّد التثبيت",
    install_open: "افتح الموقع",
    install_made_with: "صُنع باستخدام كوِّن تطبيق",

    common_loading: "جاري التحميل…",
    common_error: "حدث خطأ ما",
    common_required: "هذا الحقل مطلوب",

    nav_admin: "الإدارة",
    admin_title: "لوحة الإدارة",
    admin_subtitle: "إدارة المستخدمين والفواتير وسياسات المنصّة",
    admin_nav_dashboard: "نظرة عامّة",
    admin_nav_users: "المستخدمون",
    admin_nav_invoices: "الفواتير",
    admin_nav_policies: "السياسات",
    admin_stat_users: "المستخدمون",
    admin_stat_apps: "التطبيقات المنشأة",
    admin_stat_pro: "مشتركو Pro",
    admin_stat_free: "المجاني",
    admin_stat_invoices: "الفواتير",
    admin_stat_revenue: "الإيرادات",
    admin_stat_revenue_hint: "الإجمالي — يتفعّل بعد ربط Stripe",

    admin_users_title: "المستخدمون",
    admin_users_count: "مستخدم",
    admin_users_col_name: "الاسم",
    admin_users_col_email: "البريد الإلكتروني",
    admin_users_col_plan: "الباقة",
    admin_users_col_apps: "التطبيقات",
    admin_users_col_joined: "تاريخ الانضمام",
    admin_users_col_actions: "الإجراءات",
    admin_users_upgrade: "ترقية لـPro",
    admin_users_downgrade: "تخفيض",
    admin_users_delete_confirm: "حذف هذا المستخدم وكل تطبيقاته؟",

    admin_invoices_title: "الفواتير",
    admin_invoices_count: "فاتورة",
    admin_invoices_col_id: "رقم الفاتورة",
    admin_invoices_col_user: "المستخدم",
    admin_invoices_col_amount: "المبلغ",
    admin_invoices_col_status: "الحالة",
    admin_invoices_col_date: "التاريخ",
    admin_invoices_empty_title: "لا توجد فواتير بعد",
    admin_invoices_empty_sub: "عند دفع أوّل اشتراك Pro عبر Stripe، ستظهر الفواتير هنا تلقائياً.",
    admin_invoices_stripe_pending: "Stripe غير متّصل",

    admin_policy_terms: "شروط الخدمة",
    admin_policy_privacy: "سياسة الخصوصية",
    admin_policy_refund: "سياسة الاسترداد",
    admin_policy_cookies: "سياسة ملفات الارتباط",
    admin_policy_title_label: "عنوان السياسة",
    admin_policy_content_label: "المحتوى (Markdown — ## للعناوين)",
    admin_policy_markdown_hint: "نصيحة: استخدم `## ` في أوّل السطر لعنوان فرعي، وسطر فارغ لفقرة جديدة.",
    admin_policy_save: "حفظ السياسة",
    admin_policy_saved: "تمّ الحفظ ✓",
    admin_policy_preview: "معاينة الصفحة العامّة",
    admin_policy_updated: "آخر تحديث",

    cookie_banner_text: "نستخدم ملفات ارتباط أساسية لتشغيل ConApp. ملفات التحليلات تُحفظ فقط بعد موافقتك.",
    cookie_banner_link: "اقرأ سياسة ملفات الارتباط",
    cookie_accept: "موافق",
    cookie_decline: "الأساسية فقط",

    footer_legal: "القانوني",
    footer_terms: "الشروط",
    footer_privacy: "الخصوصية",
    footer_refund: "الاسترداد",
    footer_cookies: "ملفات الارتباط",
  },
};
